import {
  CUSTOMER_REWARD_METAFIELD_KEY,
  CUSTOMER_REWARD_METAFIELD_NAMESPACE,
} from '../../constants/rewards'

export const customerQuery = `
query customerQuery($input: String!) {
  customer(customerAccessToken: $input) {
    id
    firstName
    lastName
    acceptsMarketing
    email
    phone
    tags
    metafield(namespace: "${CUSTOMER_REWARD_METAFIELD_NAMESPACE}", key: "${CUSTOMER_REWARD_METAFIELD_KEY}") {
      key
      value
    }
    defaultAddress {
        id
        city
    }
  }
}
    `
